/* eslint-disable react-hooks/exhaustive-deps */
import {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import style from "./OrderInquirySearch.module.css";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useTranslation } from "react-i18next";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import AdminDateChoice from "routes/admin/datePicker/AdminDateChoice";
import InputText from "components/inputs/InputText";
import TestDatePicker from "components/inputs/datePicker/TestDatePicker";
import { requester } from "App";
import { useParams } from "react-router-dom";
import DateChoice2 from "components/inputs/datePicker/dateChoice/DateChoice2";
import CheckBox from "components/inputs/checkBox/CheckBox";
import { Radio, RadioGroup } from "@mui/material";

export const Types = [
  { name: "가입일", value: "regist" },
  { name: "탈퇴일", value: "delete" },
  // { name: "결제일", value: "payment" },
];
export const Searches = [
  {
    name: "이름",
    value: "name",
  },
  {
    name: "이메일",
    value: "email",
  },
  { name: "상호", value: "business_mutual" },
  { name: "사업자번호", value: "business_number" },
  { name: "대표자 성함", value: "business_name" },
  { name: "사업자 주소", value: "business_address" },
];
export const Statuses = [
  { name: "전체", value: "all" },
  { name: "활성", value: "active" },
  {
    name: "비활성",
    value: "inactive",
  },
];
const CustomerInquirySearch = forwardRef((props, ref) => {
  const { reset, setReset, research } = props;
  // const { isMobile } = useContext(BrowserDetectContext);
  const [reload, setReload] = useState(false);
  const [isMounted, setMounted] = useState(false);
  const [type, setType] = useState(Types[0].value);
  const [search, setSearch] = useState(Searches[0].value);
  const [status, setStatus] = useState(Statuses[0].value);

  const startInit = new Date(0);
  startInit.setHours(0, 0, 0, 0);
  const endInit = new Date("2999-12-31");
  endInit.setHours(23, 59, 59, 999);

  const [startDate, setStartDate] = useState(startInit);
  const [endDate, setsEndDate] = useState(endInit);

  const { t } = useTranslation();

  const dateRef = useRef();
  const input = useRef();

  //   const koreaTimeDiff = 9 * 60; // 한국은 UTC+9

  const maxDate = new Date();

  maxDate.setFullYear(maxDate.getFullYear() + 10);

  const onSearchClick = () => {
    let data = {};
    let startDateStr = dateRef.current.getStartDate().getTime();
    let endDateStr = dateRef.current.getEndDate().getTime();
    data.startDate = startDateStr;
    data.endDate = endDateStr;
    data.type = type;
    data.search = search;
    if (status !== "all") data.active = status;
    data.input = input.current.getValue();
    data.status = "table";
    // data.expand = "payments,customer,items.variant";
    // data.purchaseOrderId = inputs.current[0].getValue();
    // data.userName = inputs.current[1].getValue();
    // data.name = inputs.current[2].getValue();
    props.callback && props.callback(data);
  };
  const onInitializationClick = () => {
    input.current.setValue("");
    setStartDate(startInit);
    setsEndDate(endInit);
    dateRef.current.setActive([false, false, false, false, false]);
    // setReload(true);
    const interval = setInterval(() => {
      setReload(true);
      clearInterval(interval);
    }, 100);
  };

  const searchStyle = {
    backgroundColor: "var(--admin-main-color)",
    padding: "7px 20px",
    border: "1px solid #ddd",
  };

  const initializationStyle = {
    backgroundColor: "white",
    padding: "7px 20px",
    color: "black",
    border: "1px solid #ddd",
  };
  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if (isMounted) {
      input.current.focus();
      onInitializationClick();
    }
  }, [isMounted]);
  useEffect(() => {
    if (reset) {
      onInitializationClick();
      setReset(false);
    }
  }, [reset]);
  useEffect(() => {
    if (reload) {
      setReload(false);
      onSearchClick();
    }
  }, [reload]);
  useEffect(() => {
    if (research) onSearchClick();
  }, [research]);
  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <HorizontalFlex gap={10}>
            <FlexChild
              width={"10%"}
              backgroundColor={"var(--admin-table-bg-color)"}
            >
              <div className={style.titleWrap}>
                <Center>
                  <P size={15} weight={"bold"}>
                    기간
                  </P>
                </Center>
              </div>
            </FlexChild>
            <FlexChild>
              <HorizontalFlex gap={10}>
                <FlexChild width={"max-content"}>
                  <FlexChild width={"120px"}>
                    <select
                      className={style.select}
                      onChange={(e) => setType(e.target.value)}
                      value={type}
                    >
                      {Types?.map((type, index) => (
                        <option key={`type_${index}`} value={type.value}>
                          {type.name}
                        </option>
                      ))}
                    </select>
                  </FlexChild>
                  {/* <TestDatePicker ref={dateRef} startDate={startDate} endDate={endDate} maxDate={maxDate} /> */}
                  <DateChoice2
                    ref={dateRef}
                    startDate={startDate}
                    endDate={endDate}
                    maxDate={maxDate}
                  />
                </FlexChild>
                <FlexChild />
              </HorizontalFlex>
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
        <FlexChild>
          <HorizontalFlex gap={10} justifyContent={"flex-start"}>
            <FlexChild
              width={"10%"}
              backgroundColor={"var(--admin-table-bg-color)"}
            >
              <div className={style.titleWrap}>
                <Center>
                  <P size={15} weight={"bold"}>
                    활성화상태
                  </P>
                </Center>
              </div>
            </FlexChild>
            <FlexChild width={"max-content"}>
              <RadioGroup
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <HorizontalFlex gap={10} justifyContent={"flex-start"}>
                  {Statuses?.map((status) => (
                    <FlexChild width={"max-content"}>
                      <Radio name="publishStatus" value={status.value} />
                      <P size={15} color={"#aaa"}>
                        {status.name}
                      </P>
                    </FlexChild>
                  ))}
                </HorizontalFlex>
              </RadioGroup>
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
        <FlexChild>
          <HorizontalFlex gap={10} justifyContent={"flex-start"}>
            <FlexChild
              width={"10%"}
              backgroundColor={"var(--admin-table-bg-color)"}
            >
              <div className={style.titleWrap}>
                <Center>
                  <P size={15} weight={"bold"}>
                    검색조건
                  </P>
                </Center>
              </div>
            </FlexChild>
            <FlexChild width={"max-content"}>
              <HorizontalFlex gap={25}>
                <FlexChild width="120px">
                  <select
                    className={style.select}
                    onChange={(e) => setSearch(e.target.value)}
                    value={search}
                  >
                    {Searches?.map((search, index) => (
                      <option key={`search_${index}`} value={search.value}>
                        {search.name}
                      </option>
                    ))}
                  </select>
                </FlexChild>
                <FlexChild width={300} paddingLeft={10}>
                  <InputText
                    ref={(el) => (input.current = el)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") onSearchClick();
                    }}
                  />
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
        <FlexChild backgroundColor={"#f5f6fb"} padding={"15px 0"}>
          <HorizontalFlex gap={20}>
            <FlexChild justifyContent={"flex-end"}>
              <CustomButton
                text={"조건검색"}
                style={searchStyle}
                onClick={onSearchClick}
              />
            </FlexChild>
            <FlexChild>
              <CustomButton
                text={"초기화"}
                style={initializationStyle}
                onClick={() => setReset(true)}
              />
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
      </VerticalFlex>
    </div>
  );
});

export default CustomerInquirySearch;
